import type { TrendDataPoint } from '../../../types/weatherData';

/**
 * #676 — align the gust trend series to the sustained-wind series by timestamp,
 * returning one gust value (or null) per wind point in wind order.
 *
 * The backend builds `trends.windSpeed` and `trends.gust` by filtering the same
 * records independently, so the two arrays are not guaranteed to be the same
 * length or index-aligned. Matching by timestamp keeps the overlaid gust line
 * correct, with a null (gap) wherever a wind point has no gust reading.
 */
export function alignGustToWind(
    windSpeed: TrendDataPoint[],
    gust: TrendDataPoint[] | undefined
): (number | null)[] {
    const gustByTime = new Map((gust ?? []).map(g => [g.time, g.value]));
    return windSpeed.map(p => (gustByTime.has(p.time) ? gustByTime.get(p.time)! : null));
}
